module.exports = __webpack_public_path__ + "img/circle-orange.32b6b45a.svg";